<template>
  <nx-auth-card
    :title="$t('message.login.secondFactor.configuration.title')"
    v-on="$listeners"
  >
    <nx-auth-second-factor-configuration-form
      first-time-configuration
      v-on="$listeners"
    />
  </nx-auth-card>
</template>

<script>
import { mapState } from 'vuex';
import NxAuthSecondFactorConfigurationForm
  from '@/modules/authentication/components/AuthSecondFactorConfigurationForm.vue';
import NxAuthCard from '@/modules/authentication/components/AuthCard.vue';
import { LOGIN_PAGE_ID_LOGIN } from '@/modules/authentication/config/login-routes';

export default {
  name: 'NxAuthSecondFactorConfiguration',
  components: {
    NxAuthCard,
    NxAuthSecondFactorConfigurationForm,
  },
  computed: {
    ...mapState('authentication', ['secondFactorJwt', 'otpProvisioningUri']),
  },
  mounted() {
    if (!this.secondFactorJwt
      || !this.otpProvisioningUri
    ) {
      this.$emit('redirect', LOGIN_PAGE_ID_LOGIN);
    }
  },
};
</script>
